import { API_BASE } from '@/api/client';
import type { components } from '@/api/schema';

export type Platform = components['schemas']['Platform'];

/**
 * Domaine principal (formulaire d'inscription) ou espace d'une clinique ?
 * En cas d'erreur réseau, on suppose l'espace d'une clinique : l'écran de connexion
 * affichera lui-même le problème.
 */
export async function detectPlatform(): Promise<Platform | null> {
  try {
    const response = await fetch(`${API_BASE}/platform`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    return (await response.json()) as Platform;
  } catch {
    return null;
  }
}

/** Adresse complète d'une clinique, avec le protocole et le port de la page actuelle. */
export function clinicUrl(domain: string, location: Location = window.location): string {
  const port = location.port ? `:${location.port}` : '';
  return `${location.protocol}//${domain}${port}`;
}

/** « Clinique Saint-Émile » → « saint-emile » (proposition d'adresse). */
export function suggestAddress(name: string): string {
  const slug = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(
      /\b(clinique|centre|cabinet|polyclinique|medical|medicale|de|du|la|le|les|des|d)\b/g,
      ' ',
    )
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/^[0-9-]+/, '')
    .slice(0, 30)
    .replace(/-+$/g, '');
  return slug;
}

/** « Essai gratuit d'un mois (30 jours) » ou « Essai gratuit de 15 jours ». */
export function trialText(days: number): string {
  if (days === 30 || days === 31) return `Essai gratuit d'un mois (${days} jours)`;
  return `Essai gratuit de ${days} jours`;
}
